<template>
    <div class="authentification-form">
        <div class="form-container">
            <transition>
                <!-- Login -->
                <div
                        v-if="isLoginModeReal"
                        class="login"
                >
                    <h1 class="title">
                        {{$t('login.title')}}
                    </h1>
                    <h6 class="subtitle">
                        {{$t('login.subtitle')}}
                    </h6>
                    <a class="change-mode"
                       @click.prevent="isLoginModeReal = !isLoginModeReal"
                       href="#!"
                    >
                        {{$t('login.no_account')}}
                    </a>
                    <div class="form-box">
                        <slot name="loginForm">
                            <LoginForm @successfullLogin="successfullAuthHandler"/>
                        </slot>
                    </div>
                </div>

                <!-- Registro -->
                <div
                        v-else
                        class="register"
                >
                    <h1 class="title">
                        {{$t('register.title')}}
                    </h1>
                    <h6 class="subtitle">
                        {{$t('register.subtitle')}}
                    </h6>
                    <a class="change-mode"
                       @click.prevent="isLoginModeReal = !isLoginModeReal"
                       href="#!"
                    >
                        {{$t('register.account')}}
                    </a>
                    <div class="form-box">
                        <slot name="registerForm">
                            <RegisterForm @successfullRegister="successfullAuthHandler"/>
                        </slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
  import RegisterForm from './RegisterForm';
  import LoginForm from './LoginForm';

  export default {
      components: {
          RegisterForm,
          LoginForm,
      },
      props: {
          isLoginMode: {
              type: Boolean,
              default: true,
              required: false,
          },
      },
      data(){
          return {
              isLoginModeReal: this.isLoginMode,
          }
      },
      watch: {
          isLoginMode(){
              this.isLoginModeReal = this.isLoginMode;
          }
      },
      methods: {
          successfullAuthHandler(){
              this.$emit('sucessfullAuth', this.$auth.user());
          }
      }
  }
</script>

<style scoped lang="scss">
    @import './../styles/classes';

    .change-mode{
        color: $pallete_main_color;
        text-align: center;
        cursor: pointer;
        font-size: .9em;
        display: block;
        padding: .25em;
    }

    .authentification-form{
        flex: 1;
        display: flex;

        @media(max-width: 900px){
            padding: 50px 0;
        }

        .form-container{
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;

            .title{
                text-align: center;
                width: 100%;
                text-transform: uppercase;
                letter-spacing: 0;
                margin: 0;
            }

            .subtitle{
                text-align: center;
                width: 100%;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin: 0;
            }

            .form-box{
                padding: 30px;
                min-width: 300px;

                @media(max-width: 900px){
                    width: auto;
                    min-width: 0;
                    margin: 5px;
                }
            }
        }
    }
</style>
